import Axios from 'axios'
import notify from 'devextreme/ui/notify'
const URL = 'api/system/account'
const URL_DEVICE = 'api/system/device'
const URL_SITE = 'api/system/site'
const URL_FAVORITES = 'api/system/fav'

export default {
    namespaced: true,
    state: {
        accounts: [],
        currentSite: null,
        currentAccount: null,
        saUsers: [],
        caUsers: [],
        isDirty: false,
    },
    mutations: {
        setAccounts(state, accts) {
            state.accounts = accts ? accts : []
        },
        setCurrentSite(state, site) {
            state.currentSite = site ? site : null
        },
        setCurrentAccount(state, acct) {
            state.currentAccount = acct ? acct : null
            if (!acct) {
                state.currentSite = null
            }
        },
        setSaUsers(state, sas) {
            state.saUsers = sas ? sas : []
        },
        setCaUsers(state, cau) {
            state.caUsers = cau ? cau : []
        },
        setDirtyFlag(state, flag) {
            state.isDirty = flag ? flag : false;
        }
    },
    actions: {
        async getAccounts({ commit }) {

            this.dispatch('updateStat', true)
            return Axios.get(URL)
                .then(response => {
                    debugger
                    commit('setAccounts', response.data.msg)
                    // this.dispatch('updateStat', false);

                    return response.data.success;

                })
                .catch(err => {

                    notify(err.message, 'error')
                    // this.dispatch('updateStat', false)
                    return false;
                })
        },
        async updateAccount({ commit, state }, acct) {

            debugger;
            acct = acct ? acct : state.currentAccount


            return Axios.put(URL + "?id=" + acct.id, acct)
                .then(response => {
                    notify('Changes saved!', 'success')
                    return true
                })
                .catch(err => notify('Can\'t update account right now, ' + err.message));
        },
        async addAccount({ commit, state }, acct) {
            acct = acct ? acct : state.currentAccount;

            debugger;
            return Axios.post(URL, acct)
                .then(response => {

                    var type = response.data.success ? 'success' : 'error'
                    var msg = '';
                    if (response.data.success) {
                        msg = "Account has been added!"
                    } else {
                        msg = response.data.msg;
                    }

                    notify(msg, type, 4000);

                    return this.dispatch('accounts/getAccounts')
                        .then(() => {

                            return response.data.success;
                        })

                });
        },
        async siteSearch({ commit }, siteId) {
            return Axios.get('api/system/site?id=' + siteId)
                .then(response => {
                    commit('setCurrentSite', response.data.msg)
                    return response.data.msg;
                })
                .catch(err => notify(err.message, 'error'))
        },
        async accountSearch({ commit }, siteId) {
            return Axios.get('api/system/site?id=' + siteId)
                .then(response => {
                    commit('setCurrentSite', response.data)
                    return response.data;
                })
                .catch(err => notify(err.message, 'error'))
        },
        async getSaUsers({ commit }) {
            return Axios.get('api/system/sa')
                .then(rsp => {
                    var type = rsp.data.success ? 'success' : 'error'

                    if (type === 'success') {
                        commit('setSaUsers', rsp.data.msg)
                        return rsp.data.success;
                    } else {
                        notify(rsp.data.msg, type, 4000);
                        return rsp.data.success;
                    }
                })
                .catch(err => notify(err.message, 'error', 4000))
        },
        async getCaUsers({ commit, state }) {
            var acct = state.currentAccount;

            if (!acct) {
                return false;
            }

            return Axios.get('api/system/ca?accountId=' + acct.id)
                .then(rsp => {
                    debugger
                    var type = rsp.data.success ? 'success' : 'error';

                    if (type === 'success') {
                        commit('setCaUsers', rsp.data.msg);
                        return true;
                    } else {
                        notify(rsp.data.msg, type, 4000);
                        return false;
                    }

                })
                .catch(err => notify(err.message, 'error', 4000))
        },
        currentAccount({ commit }, acct) {
            commit('setCurrentAccount', acct)
            return;
        },
        currentSite({ commit }, site) {
            commit("setCurrentSite", site)
            return;
        },
        addDevice({ commit }, dev) {
            return Axios.post(URL_DEVICE, dev).then(response => {
                var type = response.data.success ? 'success' : 'error'

                notify(response.data.msg, type, 4000)
                return this.dispatch('accounts/getAccounts').then(rsp => {
                    return response.data.success
                });


            })
                .catch(err => notify(err.message, 'error', 4000))
        },
        removeDevice({ commit }, id) {
            return Axios.delete(URL_DEVICE + '?id=' + id)
                .then(rsp => {
                    var type = rsp.data.success ? 'success' : 'error'

                    notify(rsp.data.msg, type, 4000)
                    return rsp.data.msg
                })
                .catch(err => notify(err.message, 'error', 4000))
        },
        flagChanges({ commit }, flag) {
            commit('setDirtyFlag', flag)
            return;
        }
        // async getFavoriteItems({ state }) {

        //     debugger;
        //     if (!state.currentSite) {
        //         return []
        //     }

        //     return Axios.get(URL_SITE + '?id=' + state.currentSite.id)
        //         .then(response => {
        //             var type = response.data.success ? 'success' : 'error'

        //             if (type === 'success') {
        //                 var site = state.currentSite;

        //                 site.favorites = response.data.msg;
        //                 return site.favorites;
        //             } else {
        //                 notify(response.data.msg, type, 4000)
        //             }

        //             return []
        //         })

        // }
    },
    getters: {
        accounts: state => state.accounts,
        currentAccount: state => state.currentAccount,
        currentSite: state => state.currentSite,
        allSites: state => {
            var sites = [];

            state.accounts.forEach(acct => {

                acct.sites.forEach(site => sites.push(site))
            })

            return sites
        },
        saUsers: state => state.saUsers,
        caUsers: state => state.caUsers,
        isDirty: state => state.isDirty
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/admin/LinkDSG/dsgAccounts.js